import { Component, inject, OnDestroy } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatCard, MatCardContent, MatCardHeader, MatCardTitle } from '@angular/material/card';
import { MatSnackBar } from '@angular/material/snack-bar';
import { finalize, Subject, takeUntil } from 'rxjs';
import { AdminService } from '../../core/services/admin/admin.service';

@Component({
  selector: 'app-contact-management',
  standalone: true,
  imports: [MatButton, MatCard, MatCardHeader, MatCardTitle, MatCardContent],
  templateUrl: './contact-management.component.html',
  styleUrls: ['./contact-management.component.scss'],
})
export class ContactManagementComponent implements OnDestroy {
  private readonly adminService = inject(AdminService);
  private readonly snackBar = inject(MatSnackBar);
  private readonly destroy$ = new Subject<void>();

  public isFixingPhones = false;
  public isFixingSocialLinks = false;

  public fixPhones(): void {
    this.isFixingPhones = true;

    this.adminService
      .fixPhones()
      .pipe(
        finalize(() => (this.isFixingPhones = false)),
        takeUntil(this.destroy$),
      )
      .subscribe({
        next: (result) => this.snackBar.open(`Оновлено: ${result.updated}`, 'OK', { duration: 5000 }),
        error: () => this.snackBar.open('Не вдалося виправити телефони.', 'OK', { duration: 4000 }),
      });
  }

  public fixSocialLinks(): void {
    this.isFixingSocialLinks = true;
    this.adminService
      .fixSocialLinks()
      .pipe(
        finalize(() => (this.isFixingSocialLinks = false)),
        takeUntil(this.destroy$),
      )
      .subscribe({
        next: (result) => this.snackBar.open(`Видалено: ${result.deleted}`, 'OK', { duration: 5000 }),
        error: () => this.snackBar.open('Не вдалося виправити посилання.', 'OK', { duration: 4000 }),
      });
  }

  public ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
